export default function GetImageUrl(path: string) {
    const CLOUDINARY_BASE_URL = process.env.REACT_APP_CLOUDINARY_IMG_BASE_URL || '';

    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
    }
    return `${CLOUDINARY_BASE_URL}${path}`;
};